export default __webpack_public_path__ + "static/media/colored-square.5ec8e093.svg";